import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import moment from "moment-timezone";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import UpgradesTableRowContainer from "./UpgradesTableRowContainer";

// const countriesForFinanceTable = [
//   "NL",
//   "BE-nl",
//   "BE-fr",
//   "FR",
//   "GB",
//   "DE",
//   "ES",
//   "Overig",
// ];

class UpgradesTableContainer extends Component {
  state = {
    upgrades: [],
    perYearPerMonth: {},
    loading: false,
    end: moment(),
    start: moment().subtract(1, "weeks"),
  };

  handleStartChange = (date) => {
    this.setState({
      start: date,
    });
  };
  handleEndChange = (date) => {
    this.setState({
      end: date,
    });
  };


  loadUpgrades = () => {
    this.unsub();
    this.setState({ upgrades: [], loading: true });

    this.unsub = window.firebase
      .firestore()
      .collection("upgrades")
      .where("timestamp", "<=", this.state.end.toDate())
      .where("timestamp", ">=", this.state.start.toDate())
      .orderBy("timestamp", "desc")
      .onSnapshot((querySnapshot) => {
        let upgrades = [];
        // let perYearPerMonth = {};
        querySnapshot.forEach((doc) => {
          let upgrade = doc.data();
          upgrade["id"] = doc.id;
          if (upgrade.payed) {
            upgrade["created"] = moment(upgrade.timestamp.toDate()).unix();
            upgrades.push(upgrade);
            // let year = moment(upgrade.timestamp.toDate()).year();
            // let month = moment(upgrade.timestamp.toDate()).month();

            // if (year >= 2020) {
            //   if (perYearPerMonth[year] === undefined) {
            //     perYearPerMonth[year] = {};
            //   }
            //   if (perYearPerMonth[year][month + 1] === undefined) {
            //     perYearPerMonth[year][month + 1] = {};
            //   }

            //   let countryKey = upgrade.country;
            //   if (countryKey === "BE") {
            //     countryKey += "-" + upgrade.language;
            //   }

            //   if (countriesForFinanceTable.indexOf(countryKey) === -1) {
            //     countryKey = "Overig";
            //   }

            //   if (perYearPerMonth[year][month + 1][countryKey] === undefined) {
            //     perYearPerMonth[year][month + 1][countryKey] = 0;
            //   }

            //   perYearPerMonth[year][month + 1][countryKey] +=
            //     Math.round(
            //       (Number(upgrade.settlementAmount || upgrade.price) / 1.21) *
            //         100
            //     ) / 100;
            // }
          }
        });
        this.setState({ upgrades: upgrades, loading: false });
      });
  };

  UNSAFE_componentWillMount = () => {
    const timestamp3MonthsAgo = moment().subtract(1, "weeks").toDate();
    this.unsub = window.firebase
      .firestore()
      .collection("upgrades")
      .where("timestamp", ">=", timestamp3MonthsAgo)
      .orderBy("timestamp", "desc")
      .onSnapshot((querySnapshot) => {
        let upgrades = [];
        // let perYearPerMonth = {};
        querySnapshot.forEach((doc) => {
          let upgrade = doc.data();
          upgrade["id"] = doc.id;
          if (upgrade.payed) {
            upgrade["created"] = moment(upgrade.timestamp.toDate()).unix();
            upgrades.push(upgrade);
            // let year = moment(upgrade.timestamp.toDate()).year();
            // let month = moment(upgrade.timestamp.toDate()).month();

            // if (year >= 2020) {
            //   if (perYearPerMonth[year] === undefined) {
            //     perYearPerMonth[year] = {};
            //   }
            //   if (perYearPerMonth[year][month + 1] === undefined) {
            //     perYearPerMonth[year][month + 1] = {};
            //   }

            //   let countryKey = upgrade.country;
            //   if (countryKey === "BE") {
            //     countryKey += "-" + upgrade.language;
            //   }

            //   if (countriesForFinanceTable.indexOf(countryKey) === -1) {
            //     countryKey = "Overig";
            //   }

            //   if (perYearPerMonth[year][month + 1][countryKey] === undefined) {
            //     perYearPerMonth[year][month + 1][countryKey] = 0;
            //   }

            //   perYearPerMonth[year][month + 1][countryKey] +=
            //     Math.round(
            //       (Number(upgrade.settlementAmount || upgrade.price) / 1.21) *
            //         100
            //     ) / 100;
            // }
          }
        });
        this.setState({ upgrades: upgrades });
      });
  };

  componentWillUnmount = () => {
    this.unsub();
  };

  render() {
    return (
      <div style={{ width: "100%", marginTop: 5 }}>
        {/* <Table>
          <TableHead>
            <TableRow>
              <TableCell>Country</TableCell>
              {Object.keys(this.state.perYearPerMonth["2022"] || {})
                .sort((a, b) => b - a)
                .map((monthKey) => {
                  return (
                    <TableCell key={monthKey}>
                      {moment(monthKey, "M").format("MMMM") + " 2022"}
                    </TableCell>
                  );
                })}
              {Object.keys(this.state.perYearPerMonth["2021"] || {})
                .sort((a, b) => b - a)
                .map((monthKey) => {
                  return (
                    <TableCell key={monthKey}>
                      {moment(monthKey, "M").format("MMMM") + " 2021"}
                    </TableCell>
                  );
                })}
              {Object.keys(this.state.perYearPerMonth["2020"] || {})
                .sort((a, b) => b - a)
                .map((monthKey) => {
                  return (
                    <TableCell key={monthKey}>
                      {moment(monthKey, "M").format("MMMM") + " 2020"}
                    </TableCell>
                  );
                })}
            </TableRow>
          </TableHead>
          <TableBody>
            {countriesForFinanceTable.map((countryKey) => {
              return (
                <TableRow key={countryKey}>
                  <TableCell>{countryKey}</TableCell>
                  {Object.keys(this.state.perYearPerMonth["2022"] || {})
                    .sort((a, b) => b - a)
                    .map((monthKey) => {
                      let amount =
                        this.state.perYearPerMonth["2022"][monthKey][
                          countryKey
                        ] || 0;
                      return (
                        <TableCell key={monthKey}>
                          {"€" + Math.round(amount * 100) / 100}
                        </TableCell>
                      );
                    })}
                  {Object.keys(this.state.perYearPerMonth["2021"] || {})
                    .sort((a, b) => b - a)
                    .map((monthKey) => {
                      let amount =
                        this.state.perYearPerMonth["2021"][monthKey][
                          countryKey
                        ] || 0;
                      return (
                        <TableCell key={monthKey}>
                          {"€" + Math.round(amount * 100) / 100}
                        </TableCell>
                      );
                    })}
                  {Object.keys(this.state.perYearPerMonth["2020"] || {})
                    .sort((a, b) => b - a)
                    .map((monthKey) => {
                      let amount =
                        this.state.perYearPerMonth["2020"][monthKey][
                          countryKey
                        ] || 0;
                      return (
                        <TableCell key={monthKey}>
                          {"€" + Math.round(amount * 100) / 100}
                        </TableCell>
                      );
                    })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table> */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "baseline",
            paddingLeft: 15,
            marginBottom: 5,
          }}
        >
          <KeyboardDatePicker
            margin="normal"
            name="start"
            label="Start"
            format={languages.createTournament.dateFormat}
            cancelLabel={languages.createTournament.cancel}
            autoOk={true}
            value={this.state.start}
            onChange={this.handleStartChange}
            placeholder={languages.createTournament.datePlaceholder}
            invalidLabel={languages.createTournament.invalidDateLabel}
          />
          <KeyboardDatePicker
            margin="normal"
            name="end"
            label="End"
            format={languages.createTournament.dateFormat}
            cancelLabel={languages.createTournament.cancel}
            autoOk={true}
            value={this.state.end}
            onChange={this.handleEndChange}
            placeholder={languages.createTournament.datePlaceholder}
            invalidLabel={languages.createTournament.invalidDateLabel}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={this.loadUpgrades}
            style={{ height: "30px" }}
            disabled={this.state.loading}
          >
            Submit
          </Button>
        </div>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ paddingRight: 0 }}>Date</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Uid</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Tournament</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Package</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Revenue(€)</TableCell>
              <TableCell style={{ paddingRight: 0 }}>VAT%</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Method</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Cur.</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Invoice</TableCell>
              {/* <TableCell>TournamentId</TableCell> */}
              {/* <TableCell>Invoice</TableCell> */}
              <TableCell style={{ paddingRight: 0 }}>Email</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Firstname</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Lastname</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Company</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Address</TableCell>
              <TableCell style={{ paddingRight: 0 }}>Country</TableCell>
              <TableCell style={{ paddingRight: 0 }}>VAT#</TableCell>

              {/* <TableCell>IP</TableCell> */}
              <TableCell style={{ paddingRight: 0 }}>Domain</TableCell>
              <TableCell>Lang.</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.upgrades.map((upgrade) => (
              <UpgradesTableRowContainer key={upgrade.id} upgrade={upgrade} />
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default UpgradesTableContainer;
